import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { SalienteLibrarySharedModule } from '@saliente/library';
import { DuPFAKeezSharedModule } from 'src/app/client-forms/du-pfa-keez-form/du-pfa-form-shared.module';
import { MicroProfitSharedModule } from 'src/app/client-forms/micro-profit-form/micro-profit-form-shared.module';
import { MP2024FormSharedModule } from 'src/app/client-forms/mp2024-form/mp2024-form-shared.module';
import { DuPFA2024SharedModule } from "../../client-forms/dupfa2024-form/dupfa2024-form-shared.module";
import { DocumentDisplaySharedModule } from '../document-display';
import { ChatMarkAnsweredDialogComponent } from './chat-mark-answered-dialog.component';
import { ChatComponent } from './chat.component';
import { MeetingRequestDialog } from './meetings/meeting-request-dialog';
import { TimeSlotsDialog } from './meetings/time-slots-dialog';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ReleaseNotesSharedModule } from '../release-notes/release-notes-shared.module';
import { DuPFA2025SharedModule } from 'src/app/client-forms/dupfa2025-form/dupfa2025-form-shared.module';

const COMPONENTS = [ ChatComponent, ChatMarkAnsweredDialogComponent, TimeSlotsDialog, MeetingRequestDialog ];

@NgModule({
	imports: [
		CommonModule, FormsModule, RouterModule, ScrollingModule, SalienteLibrarySharedModule, DocumentDisplaySharedModule,
		MicroProfitSharedModule, DuPFAKeezSharedModule, MP2024FormSharedModule, DuPFA2024SharedModule, DuPFA2025SharedModule,
		DateInputsModule, PdfViewerModule, ReleaseNotesSharedModule
	],
	declarations: [
		...COMPONENTS
	],
	exports: [
		...COMPONENTS
	]
})
export class CommonNotificationsSharedModule {
}